import { Component, Input, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { AclService } from 'ng2-acl/dist';
import { FusePerfectScrollbarDirective } from '@fuse/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';

import { navigation } from 'app/navigation/navigation';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { DataService } from '../../services/data.service';

@Component({
    selector     : 'fuse-navbar',
    templateUrl  : './navbar.component.html',
    styleUrls    : ['./navbar.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FuseNavbarComponent implements OnDestroy
{
    private fusePerfectScrollbar: FusePerfectScrollbarDirective;

    @ViewChild(FusePerfectScrollbarDirective) set directive(theDirective: FusePerfectScrollbarDirective)
    {
        if ( !theDirective )
        {
            return;
        }

        this.fusePerfectScrollbar = theDirective;

        this.navigationServiceWatcher =
            this.navigationService.onItemCollapseToggled.subscribe(() => {
                this.fusePerfectScrollbarUpdateTimeout = setTimeout(() => {
                    this.fusePerfectScrollbar.update();
                }, 310);
            });
    }

    @Input() layout;
    navigation: any;
    navigationServiceWatcher: Subscription;
    fusePerfectScrollbarUpdateTimeout;

    constructor(
        private sidebarService: FuseSidebarService,
        private navigationService: FuseNavigationService,
        private dataService: DataService,
        private aclService: AclService
    )
    {
        this.dataService.isLoggedIn.subscribe(res => {
            if (res) {
                setTimeout(() => {
                    const nav = this.copy(navigation);
                    this.navigation = this.reduceNavByPermissions(nav);
                });
            } else {
                this.navigation = [];
            }
        });
        
        // Default layout
        this.layout = 'vertical';
    }

    copy(o) {
        let output, v, key;
        output = Array.isArray(o) ? [] : {};
        for (key of Object.keys(o)) {
            v = o[key];
            output[key] = (typeof v === 'object') ? this.copy(v) : v;
        }
        return output;
    }

    reduceNavByPermissions(nav)
    {
        for ( let i = 0; nav.length > i; i++ )
        {
            if ( nav[i].type === 'item' )
            {
                if (nav[i].permission) {
                    if (!this.aclService.can((nav[i].permission))) {
                        nav.splice(nav.indexOf(nav[i]), 1);
                        this.reduceNavByPermissions(nav);
                    }
                }
            }

            if (nav[i] && (nav[i].type === 'collapse' || nav[i].type === 'group'))
            {
                if (nav[i].permission) {
                    if (this.aclService.can((nav[i].permission))) {
                        if ( nav[i].children )
                        {
                            this.reduceNavByPermissions(nav[i].children);
                        }
                    } else {
                         nav.splice(nav.indexOf(nav[i]), 1);
                         this.reduceNavByPermissions(nav);
                    }
                } else if ( nav[i].children )
                {
                    this.reduceNavByPermissions(nav[i].children);
                }
            }
        }
        return nav;
    }

    ngOnDestroy()
    {
        if ( this.fusePerfectScrollbarUpdateTimeout )
        {
            clearTimeout(this.fusePerfectScrollbarUpdateTimeout);
        }

        if ( this.navigationServiceWatcher )
        {
            this.navigationServiceWatcher.unsubscribe();
        }
    }

    toggleSidebarOpened(key)
    {
        this.sidebarService.getSidebar(key).toggleOpen();
    }

    toggleSidebarFolded(key)
    {
        this.sidebarService.getSidebar(key).toggleFold();
    }
}



// WEBPACK FOOTER //
// ./src/app/main/navbar/navbar.component.ts